import React from "react";
import "./Bonus.css";
import Presente from '../../assets/imgs/1f381.svg';
function Bonus() {
  return (
    <div class="bonus-wrapper">
      <div className="bonus-container">
        <h2>
          Como se tudo isso já não fosse o bastante, você ainda terá de bônus:
        </h2>
        <div className="bonus-itens-container">
          <div>
            <img alt='insigne' src={Presente}></img>
            <h3>Modelos prontos dos principais trabalhos acadêmicos.</h3>
            <p>
              Resumo Simples, Resumo Expandido, Draft, Artigo Científico,
              Trabalho de Conclusão de Curso (TCC – Graduação), Dissertação,
              Tese, Projeto de Pesquisa e muito mais!
            </p>
          </div>
          <div>
            <img alt='insigne' src={Presente}></img>
            <h3>
              E-books de diversas áreas do conhecimento com 500 temas (e como
              utilizá-los) no momento da escolha da sua área de pesquisa
            </h3>
            <p></p>
          </div>
          <div>
            <img alt='insigne' src={Presente}></img>
            <h3>
              Acesso ao chat da Plataforma para esclarecer qualquer dúvida
              durante seu estudo!
            </h3>
          </div>
          <div>
            <img alt='insigne' src={Presente}></img>
            <h3>
              Acesso vitalício (eu disse VITALÍCIO) à Comunidade Insigne de
              Pesquisa
            </h3>
            <p>
              (grupo de whatsapp com pesquisadores de todo o Brasil e de
              Portugal) (Vou explicar como funciona a Comunidade dentro da
              Plataforma, tá bom?).
            </p>
          </div>
          <div>
            <img alt='insigne' src={Presente}></img>
            <h3>
              Obras das edições anteriores do Congresso Brasileiro de Direito
              Aplicado
            </h3>
            <p>mais de 150 trabalhos publicados para inspirar suas pesquisas</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bonus;
